import DialogTitle from '@mui/material/DialogTitle';
import {
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {
  DialogActionButton,
} from '@finpay-development/shared-components';
import Dialog from '@mui/material/Dialog';
import React, {useState} from 'react';
import _ from 'lodash';
import {useDispatch} from 'react-redux';
import {showErrorStatus} from '../../security/state/user-slice';
import {AppDispatch} from '../../shared/state/store';

type SearchPatientResultsModalProps = {
  onClose: () => void
  searchResult: Record<string, any>[]
  onPatientSelect: (selectedPatient: SelectedPatient) => Promise<void>
}

export type SelectedPatient = Record<string, any> | 'new'

export const SearchPatientResultsModal = (props: SearchPatientResultsModalProps) => {


  const {
      onClose,
      searchResult = [],
      onPatientSelect
  } = props

  const dispatch = useDispatch<AppDispatch>();

  const [selectedPatient, setSelectedPatient] = useState<SelectedPatient | null>(null)
  const [isFormProcessing, setIsFormProcessing] = useState(false)

  const getLabel = (patientRecord: Record<string, any>) => {

    const firstName = _.capitalize(patientRecord?.contact?.firstName || "")
    const lastName = _.capitalize(patientRecord?.contact?.lastName || "")
    const birthDate = patientRecord?.contact?.birthDate ? `(${patientRecord?.contact?.birthDate.replace(
        /(\d{4})-(\d{2})-(\d{2})/,
        "$2-$3-$1"
    )})` : ""

    return (
        <>
          <Typography>{`${firstName} ${lastName} ${birthDate}`}</Typography>
          {patientRecord?.contact?.email && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {patientRecord.contact.email}
              </Typography>
          )}
        </>
    )

  }

  return (
      <Dialog
          className="modal"
          sx={{ padding: "4rem" }}
          open={true}
          fullWidth={true}
          maxWidth="md"
          scroll="paper"
      >
        <DialogTitle>Patient Search Result</DialogTitle>

        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ paddingBottom: "1rem" }}>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={12} direction="column">
              {
                searchResult.map((patientRecord) => (
                    <FormControlLabel
                      sx={{ display: 'flex', mb: 1.5 }}
                      key={patientRecord.patientId}
                      control={
                        <Radio checked={selectedPatient === patientRecord} />
                      }
                      onClick={() => setSelectedPatient(patientRecord)}
                      label={getLabel(patientRecord)}
                    />
                ))
              }
              <FormControlLabel
                  sx={{ display: 'flex', mt: 1.5 }}
                  control={
                    <Radio checked={selectedPatient === 'new'} />
                  }
                  onClick={() => setSelectedPatient('new')}
                  label="Create new patient"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
            // test-id="ioc-modal-buttons"
        >
          <DialogActionButton
              isEnabled={!isFormProcessing}
              savebuttonText="Select"
              saveStatus={0}
              executeSave={async ()=>{
                if(selectedPatient === null){
                  dispatch(showErrorStatus("Please select an option before continuing"))
                }else{
                  try{
                    setIsFormProcessing(true)
                    await onPatientSelect(selectedPatient)
                  }finally{
                    setIsFormProcessing(false)
                  }
                }
              }}
              handleCallbackSave={onClose}
              handleCallbackCancel={onClose}
              // test-id='ioc-modal-save-btn'
          />
        </DialogActions>
      </Dialog>
  )

}